import ActionModal from 'components/ActionModal';
import React from 'react';
import { CONTACT_HOST_SOURCES } from '~/constants';

import useContactHostSending from './hooks/useContactHostSending';

interface ContactHostSendingModalProps {
  source: CONTACT_HOST_SOURCES;
}

const ContactHostSendingModal: React.FC<ContactHostSendingModalProps> = ({
  source,
}) => {
  useContactHostSending({ source });

  return <ActionModal text="Sending request" />;
};

export default ContactHostSendingModal;
